export const BLOG_NEW_FEATURES_TOUR_ID = 'blog-new-features';
export const TOUR_STEP_PUBLISHING = 'publishing';
export const TOUR_STEP_DISTRACTION_FREE = 'distraction-free';
export const blogNewFeaturesTourSteps = {
  TOUR_STEP_PUBLISHING,
  TOUR_STEP_DISTRACTION_FREE
};